const PotentialMalwareIcon = ({id}:{id:string}) => {
  return (
    <svg
        width={25}
        height={25}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <mask
            id={id}
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={25}
            height={25}
        >
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.09351 0.228823C7.24002 0.08231 7.43873 0 7.64594 0H17.3541C17.5613 0 17.76 0.08231 17.9065 0.228823L24.7712 7.09351C24.9177 7.24002 25 7.43873 25 7.64594V17.3541C25 17.5613 24.9177 17.76 24.7712 17.9065L17.9065 24.7712C17.76 24.9177 17.5613 25 17.3541 25H7.64594C7.43873 25 7.24002 24.9177 7.09351 24.7712L0.228823 17.9065C0.08231 17.76 0 17.5613 0 17.3541V7.64594C0 7.43873 0.08231 7.24002 0.228823 7.09351L7.09351 0.228823ZM7.96954 1.5625L1.5625 7.96954V17.0305L7.96954 23.4375H17.0305L23.4375 17.0305V7.96954L17.0305 1.5625H7.96954Z"
            fill="black"
            />
            <path
            d="M10.9399 17.1875C10.9399 16.3246 11.6395 15.625 12.5024 15.625C13.3654 15.625 14.0649 16.3246 14.0649 17.1875C14.0649 18.0504 13.3654 18.75 12.5024 18.75C11.6395 18.75 10.9399 18.0504 10.9399 17.1875Z"
            fill="black"
            />
            <path
            d="M11.093 7.80475C11.0097 6.97232 11.6634 6.25 12.5 6.25C13.3366 6.25 13.9903 6.97232 13.907 7.80475L13.359 13.2851C13.3149 13.7264 12.9435 14.0625 12.5 14.0625C12.0565 14.0625 11.6851 13.7264 11.641 13.2851L11.093 7.80475Z"
            fill="black"
            />
        </mask>
        <g mask={`url(#${id})`}>
            <rect width={25} height={25} fill="#0EC9AC" />
        </g>
    </svg>
  )
}

export default PotentialMalwareIcon